import { Box, Text } from '@chakra-ui/react';

import { Link } from '~/components/link';
import { trackEvent } from '~/features/analytics/track-event';

import { usePromotion } from '../hooks/use-promotion';

export function PriceCardSticker({ programKey }: { programKey?: string }) {
  const { data: promotion } = usePromotion();
  const heroSticker = promotion?.heroSticker;
  if (!heroSticker) return null;
  const { linkLabel, linkUrl, text } = heroSticker;
  function fireTrackEvent() {
    trackEvent({
      type: 'click',
      name: 'Product Page CTA Clicked',
      label: 'hero_sticker_clicked',
      value: promotion?.promotionId,
      additionalAttributes: {
        product_ids: [programKey],
      },
    });
  }
  return (
    <Box borderTop='dashed 1px' borderTopColor='gray.200' mt='16px' pt='16px' textAlign='center'>
      <Text fontWeight='700'>
        {text}{' '}
        {linkUrl && linkLabel && (
          <Link
            href={linkUrl}
            textDecoration='underline'
            whiteSpace='nowrap'
            onClick={(e) => {
              fireTrackEvent();
              e.stopPropagation();
            }}
          >
            {linkLabel}
          </Link>
        )}
      </Text>
    </Box>
  );
}
